import { RPKRepository } from '@/core/repositories/rpk.repository'
import {
    RaketaRPKListResponseT,
    RaketaRPKPayloadT,
    RaketaRPKResponseT,
    RPKCreatePayloadT,
    RPKExportExcelParamsT,
    RPKListParamsT,
    RPKListResponseT,
    RPKPayloadT,
    RPKResponseT,
    RPKTypesResponseT,
} from '@/core/types/rpk.types'

const rpkRepository = new RPKRepository()

export class RPKService {
    async getRaketaRPKList(params: RPKListParamsT): Promise<RaketaRPKListResponseT> {
        const response = await rpkRepository.getRaketaRPKList(params)
        return response.data
    }

    async getRPKList(params: RPKListParamsT): Promise<RPKListResponseT> {
        const response = await rpkRepository.getRPKList(params)
        return response.data
    }

    async getRaketaRPK(id: number): Promise<RaketaRPKResponseT> {
        const response = await rpkRepository.getRaketaRPK(id)
        return response.data
    }

    async getRPK(id: number): Promise<RPKResponseT> {
        const response = await rpkRepository.getRPK(id)
        return response.data
    }

    async getTypes(): Promise<RPKTypesResponseT> {
        const response = await rpkRepository.getTypes()
        return response.data
    }

    async changeStatusRPK(rpp_id: number, status_code: string): Promise<void> {
        await rpkRepository.changeStatusRPK(rpp_id, status_code)
    }

    async editRaketaRPK(payload: RaketaRPKPayloadT): Promise<void> {
        const response = await rpkRepository.editRaketaRPK(payload)
        return response.data
    }

    async editRPK(payload: RPKPayloadT): Promise<void> {
        const response = await rpkRepository.editRPK(payload)
        return response.data
    }

    async exportExcel(params: RPKExportExcelParamsT): Promise<any> {
        const response = await rpkRepository.exportExcel(params)
        return response.data
    }

    async exportExcelRaketa(id: number): Promise<any> {
        const response = await rpkRepository.exportExcelRaketa(id)
        return response.data
    }

    async createRaketaRPK(payload: RPKCreatePayloadT): Promise<void> {
        const response = await rpkRepository.createRaketaRPK(payload)
        return response.data
    }

    async deleteRPK(id: number): Promise<void> {
        const response = await rpkRepository.deleteRPK(id)
        return response.data
    }
}
